// Приховані баланси («режим інкогніто»): подвійний тап по балансу на
// головній ховає всі баланси й суми у виписці — замість них прапор України.
// Стан спільний для всіх екранів і переживає перезапуск (localStorage).
import { useCallback, useSyncExternalStore } from 'react';

const STORAGE_KEY = 'balances_hidden';
export const HIDDEN_BALANCE = '🇺🇦';

const listeners = new Set();

let hidden = (() => {
  try { return localStorage.getItem(STORAGE_KEY) === '1'; } catch (e) { return false; }
})();

function subscribe(listener) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

const getSnapshot = () => hidden;

export function setBalancesHidden(value) {
  hidden = Boolean(value);
  try { localStorage.setItem(STORAGE_KEY, hidden ? '1' : '0'); } catch (e) { /* ignore */ }
  listeners.forEach((l) => l());
}

export function useBalancesHidden() {
  const value = useSyncExternalStore(subscribe, getSnapshot);
  const toggle = useCallback(() => setBalancesHidden(!hidden), []);
  return [value, toggle];
}

// Сума або прапор, якщо баланси приховано
export function useMaskBalance() {
  const [isHidden] = useBalancesHidden();
  return (text) => (isHidden ? HIDDEN_BALANCE : text);
}
